import { FileOpen } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { requestRoutesByType } from "shared/config";

export function OpenRequestButton({ requestType, requestNumber }) {
  const { t } = useTranslation("Shared");
  return (
    <Tooltip title={t("buttons.open_request")} placement="top">
      <IconButton
        component={Link}
        to={`${requestRoutesByType[requestType]}/${requestNumber}`}
      >
        <FileOpen fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
